import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../../api/api.service';
import { ItistateapiService } from '../../../api/itistateapi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";
import { element } from 'protractor';

@Component({
  selector: 'app-showstatetable',
  templateUrl: './showstatetable.component.html',
  styleUrls: ['./showstatetable.component.css']
})
export class ShowstatetableComponent implements OnInit {

  public bool_blck_screen: boolean = false;  
  public bool_list_table: boolean = false;
  public bool_view_table: boolean = false;
  public bool_popup: boolean = false;
  public bool_iti_state_table: boolean = false;
  public bool_offline_form: boolean = false;
  public seltable: any = [];
  public objBool: boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns = ['slno', 'iticode', 'name', 'district', 'update'];
  SRC_SELECTED_FAMILYMEMBER: Element[] = [];
  DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
  dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
  selected_family_member = new SelectionModel<Element>(true, []);
  public int_index_edit: any;

  @ViewChild('paginator_Iti_state') paginator_Iti_state!: MatPaginator;
  @ViewChild('sort_Iti_state') sort_Iti_state!: MatSort;

  displayedColumns_iti_state = ['select', 'slno', 'iticode', 'name', 'count'];
  SRC_SELECTED_ITI_State: Element[] = [];
  DATA_SELECTED_ITI_State = Object.assign(this.SRC_SELECTED_ITI_State);
  dataSource_ITI_State = new MatTableDataSource<Element>(this.DATA_SELECTED_ITI_State);
  selected_iti_state = new SelectionModel<Element>(true, []);
  public int_index_edit_Master: any;
  totallength_ITI_State: any = 1;


  @ViewChild('paginator_payMaster') paginator_payMaster!: MatPaginator;
  @ViewChild('sort_payMaster') sort_payMaster!: MatSort;

  displayedColumnspayMaster = ['slno', 'payrefid', 'payrefdate', 'noofstu', 'amount', 'ccaveref', 'paymentdate', 'pstatus'];
  SRC_SELECTED_FAMILYMEMBER_payMaster: Element[] = [];
  DATA_SELECTED_FAMILYMEMBER_payMaster = Object.assign(this.SRC_SELECTED_FAMILYMEMBER_payMaster);
  dataSource_payMaster = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER_payMaster);
  selected_family_member_payMaster = new SelectionModel<Element>(true, []);
  public int_index_edit_payMaster: any;
  totallength_paymaster: any = 1;

  public pduTable: any;
  public query: string = '';
  public page: number = 1;
  public offset: number = 5;
  public pageEvent: any;
  totallength: any = 1;
  public itiForm: any;
  public nimiForm: any;
  submitted = false;

  @ViewChild('paginator_ITI_Student') paginator_ITI_Student!: MatPaginator;
  @ViewChild('sort_ITI_Student') sort_ITI_Student!: MatSort;

  displayedColumnsDistrict = ['select', 'slno', 'rollnumber', 'name', 'trade', 'exam'];
  SRC_SELECTED_ITI_Student: Element[] = [];
  DATA_SELECTED_ITI_Student = Object.assign(this.SRC_SELECTED_ITI_Student);
  dataSource_ITI_Student = new MatTableDataSource<Element>(this.DATA_SELECTED_ITI_Student);
  selected_family_member_District = new SelectionModel<Element>(true, []);
  public int_index_edit_District: any;
  totallength_ITI_Student: any = 1;

  public bool_paynow: boolean = true;
  public bool_offln_submit: boolean = false;

  
  reciveuserid: any;
  reciveMobilemo: any;
  reciveemail: any;
  reciveeITIStateCode: any;
  reciveeITIStateName: any;

  element: any;
  constructor(private formBuilder: FormBuilder, private api: ApiService, private itistateapi: ItistateapiService, private router: Router, private httpClient: HttpClient) { }  

  public enter_date: any;
  public state: any;
  ngOnInit(): void {
    const d = new Date();
    var month = d.getMonth() + 1;

    this.enter_date = d.getDate() + "/" + month + "/" + d.getFullYear();

    this.itistateapi.listITIstate().subscribe((data: any) => {
      this.state = data;
      //console.log(data);
    });


    this.reciveuserid = window.localStorage.getItem('ITIStateLoginId');
    this.reciveemail = window.localStorage.getItem('ITIStateEmail');
    this.reciveMobilemo = window.localStorage.getItem('ITIStateMobile');
    this.reciveeITIStateCode = window.localStorage.getItem('ITIStateCode');
    this.reciveeITIStateName = window.localStorage.getItem('state');
    this.nimiForm = this.formBuilder.group({
      paymode: ['', Validators.required],
      refno: ['', Validators.required],
      state: ['', Validators.required],
      amount: ['', Validators.required],
      date: ['', Validators.required],
      // name: ['', Validators.required ],
      // email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      // mobileno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      // niminumberofstud: ['', Validators.required],
      // paymethod: ['',  Validators.required],
      // ascmob: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      // utr: ['', Validators.required],
      // radiobtn: ['', Validators.required ],
      // bulkrollno: ['', ],
      // descreption: ['', [Validators.maxLength(500)]],
      // acceptTerms: [false, Validators.requiredTrue],
      // nimiqualification: this.formBuilder.array([]),
      // enterDate: [this.enter_date],

    });

  }

  get f() {
    return this.nimiForm.controls;
  }

  fn_show_view_selct() {
    this.bool_list_table = false;
    this.bool_view_table = true;
    this.bool_iti_state_table = true;
    this.bool_offline_form = false;

    this.seltable = [];
    this.selected_iti_state.clear();
    this.totCount = 0;
    this.studcount = 0; 
    this.itiForm = this.formBuilder.group({
      // iticode: ['', Validators.required],
      state: window.localStorage.getItem('state'),
      key: window.localStorage.getItem('statekey')
    });     
    this.itistateapi.showStateItiCountTable(this.itiForm.value).subscribe((result: any) => { 
      this.SRC_SELECTED_ITI_State = result;
      this.DATA_SELECTED_ITI_State = Object.assign(this.SRC_SELECTED_ITI_State);
      this.dataSource_ITI_State = new MatTableDataSource<Element>(this.DATA_SELECTED_ITI_State);
      this.dataSource_ITI_State.paginator = this.paginator_Iti_state;
      this.dataSource_ITI_State.sort = this.sort_Iti_state;
      this.totallength_ITI_State = result.length; 
    });
  } 
  
  public totCount: number = 0;
  public studcount: number = 0;
  public totCountArray: any = [];

  public view_bool_disble: boolean = true;
  public sel_stud_arry: any = {};
  public sel_state_arry: any = {};
  
  fn_select_iti_state_row(event: any, element: any, i: any) {

    let count = element.count;
    let mulValue = count * 376;

    this.bool_paynow = false;
    var args = {
      iticode: element.ITICode
    }
    if (event.checked) {
      this.itistateapi.showStateItiDistrictTable(args).subscribe(async (result: any) => {
        result.forEach((row: any) => this.sel_stud_arry[row.RollNumber] = row);
        console.log(this.sel_state_arry[element.ITICode] = element.ITICode);
      });
    }
    else {
      this.itistateapi.showStateItiDistrictTable(args).subscribe(async (result: any) => {
        result.forEach((row: any) => delete this.sel_stud_arry[row.RollNumber]);
      });

    }

    if (this.studcount == 0) {
      this.bool_paynow = true;
    }

  }

  public fn_getCount() {
    var keys = Object.keys(this.sel_stud_arry);
    var len = keys.length;
    return len;
  }

  public number_count: any = 0;
  public itiCodeView: any;
  public itiNameView: any;
  public arr_check: any = [];

  fn_view_iti_state(element: any) {
    console.log(JSON.stringify(element))
    var args = {
      iticode: element.ITICode
    }
    this.itiCodeView = element.ITICode;
    this.itiNameView = element.ITIName;
    this.itistateapi.showStateItiDistrictTable(args).subscribe(async (result: any) => { 
      this.bool_popup = true;
      this.bool_iti_state_table = false;
      this.SRC_SELECTED_ITI_Student = result;
      this.DATA_SELECTED_ITI_Student = Object.assign(this.SRC_SELECTED_ITI_Student);
      this.dataSource_ITI_Student = new MatTableDataSource<Element>(this.DATA_SELECTED_ITI_Student);
      this.dataSource_ITI_Student.paginator = this.paginator_ITI_Student;
      this.dataSource_ITI_Student.sort = this.sort_ITI_Student;
      this.totallength_ITI_Student = result.length;
    });

      // await result.map((x: any) => {
      //   let b: any = JSON.stringify(this.selected_family_member_District.selected.length);
      //   if (b > 0) {
      //   }
      //   else {
      //   } 
      //   for (let i = 0; i < this.sel_stud_arry.length; i++) {
      //     if (x.RollNumber == this.sel_stud_arry[i]['RollNumber']) {
      //       console.log(x.RollNumber + ' ' + JSON.stringify(this.sel_stud_arry[i]['RollNumber']));
      //       x.checked = true;
      //       return x;
      //     }
      //   } 
      // });


  }
  
  fn_select_iti_student(event: any, element: any) {
    alert('test');
    if (event.checked) {
      this.sel_stud_arry[element.RollNumber] = element;
      //this.sel_stud_arry[element.ITICode] = element.ITICode;
      let count = this.fn_getCount();
      let mulValue = count * 376;
      this.totCount = mulValue;
      this.studcount = count;
    }
    else {
      delete this.sel_stud_arry[element.RollNumber];
      let count = this.fn_getCount();
      let mulValue = count * 376;
      this.totCount = mulValue;
      this.studcount = count;

    }
  }

  fn_isSelected_student(element: any) {
    // console.log("is select" + JSON.stringify(element));
    let res = this.sel_stud_arry.hasOwnProperty([element.RollNumber]);
    //    console.log(res)
    if (res) {
      //console.log(true);
      return true;
    } else {
      // console.log(false);
      return false;
    }
  }

  public total_student: any;
  public total_amount: any;

  fn_isAllSelected_student() {

    const numSelected = this.selected_family_member_District.selected.length;
    const numRows = this.dataSource_ITI_Student.data.length;
    this.total_student = this.studcount;
    this.total_amount = this.totCount * 376;


    let count = this.fn_getCount();
    let mulValue = count * 376;
    this.totCount = mulValue;
    this.studcount = count;


    if (this.studcount !== 0) {
      this.bool_paynow = false;
    }
    else {
      this.bool_paynow = true;
    }

    return numSelected === numRows;
  }


  async fn_masterToggle(event: any) {
    if (event.checked) {
      this.dataSource_ITI_Student.data.forEach((row: any) => this.sel_stud_arry[row.RollNumber] = row);

      //this.selected_family_member_District.clear();
    }
    else {
      this.dataSource_ITI_Student.data.forEach((row: any) => delete this.sel_stud_arry[row.RollNumber]);

    }

  }

 


  fn_paynow() {
    this.bool_paynow = true;

    console.log(this.sel_stud_arry);
    this.selected_iti_state.selected.forEach((s) => {
      this.seltable.push(s);
    });

    this.seltable.forEach((value: any, key: any) => {
      value['comanId'] = { commanloginid: this.reciveuserid, commanlemail: this.reciveemail, commanlmobile: this.reciveMobilemo, commanstudCount: this.studcount };
    });

    this.seltable = []; 
  }

  public Args: any;

  fn_click_updt() { 
    this.seltable = [];
    this.selected_iti_state.clear();
    this.bool_paynow = true;
    this.bool_list_table = true;
    this.bool_view_table = false;
    this.bool_iti_state_table = false;
    this.studcount = 0;
    this.totCount = 0;

    this.itiForm = this.formBuilder.group({
      // iticode: ['', Validators.required],
      state: window.localStorage.getItem('state'),
      key: window.localStorage.getItem('statekey')
    });

    this.Args = {
      state: window.localStorage.getItem('state'),
      key: window.localStorage.getItem('statekey'),
      query: '',
      page: '1',
      offset: '5',
    };


    this.itistateapi.showStateItiTable(this.Args).subscribe((result: any) => {
      console.log(JSON.stringify(result))
      this.SRC_SELECTED_FAMILYMEMBER = result;
      this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
      this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.itistateapi.showItiTableLimitCount(this.Args).subscribe((result: any) => {
        this.totallength = result[0]['count'];
        console.log(this.totallength);
      });


      console.log(this.totallength + result[0]['iticode']);

    });

  }

  pageChanged(event: any) {
    this.page = parseInt(event.pageIndex) + 1;
    this.offset = parseInt(event.pageSize);

    this.Args = {
      state: window.localStorage.getItem('state'),
      key: window.localStorage.getItem('statekey'),
      query: '',
      page: this.page,
      offset: this.offset,
    };

    console.log(this.page + " , " + this.offset)
    this.itistateapi.showStateItiTable(this.Args).subscribe((result: any) => {
      this.dataSource = new MatTableDataSource(result);
      console.log(JSON.stringify(result));


    })
  }

  updated_fn() {

    this.bool_blck_screen = true;
    this.selected_family_member.selected.forEach((item) => {
      var msg = JSON.stringify(item);
      //console.log("MSG: " + msg)
      var parsedarray = JSON.parse(msg);

      var args = {
        iticode: parsedarray.iticode
      }
      this.itistateapi.getUpdateTraineeData(args).subscribe((res: any) => {
        this.bool_blck_screen = false;
        this.selected_family_member.clear();
        let status = res.status;
        if (status == 'succes') {
          this.fn_click_updt();
        }
        alert(status);
      });
    })

  }



  payMasterView() {

  }

  payMaster() { }

  close_fn() {
    this.bool_popup = false;
    this.bool_iti_state_table = true;
  }

  offln_form_fn() {
    this.seltable = [];
    this.bool_paynow = true;
    this.selected_iti_state.selected.forEach((s) => {
      this.seltable.push(s);
    });

    this.bool_iti_state_table = false;
    this.bool_view_table = false;
    this.bool_offline_form = true;


  }

  onnimiSubmit() {

    this.submitted = true;

    if (this.nimiForm.invalid) {
      alert('Fill the form');
      return;
    }
    this.bool_offln_submit = true;

    this.seltable.forEach((value: any, key: any) => {
      value['comanId'] = { commanloginid: this.reciveuserid, commanlemail: this.reciveemail, commanlmobile: this.reciveMobilemo, commanstudCount: this.studcount, offlineform: this.nimiForm.value };
    });
    console.log(JSON.stringify(this.seltable));

    this.itistateapi.importStateOfflineTable(this.seltable).subscribe((result: any) => {
      this.seltable = [];
      let status = result.status;

      if (status == 'success') {
        this.router.navigateByUrl('/examfeestate/showpaytable')

      }
    });

  }

  onReset() { }

  public date = new Date().getDate();
  public month = new Date().getMonth() + 1;
  public year = new Date().getFullYear();
  public currentDate = this.date + '-' + this.month + '-' + this.year;

  datePickerConfig = {
    format: 'DD-MM-YYYY',
    min: '01-12-2020',
    max: '31-03-2021'
    //max: this.currentDate,
  };

  datePickerConfigDir = {
    format: 'DD-MM-YYYY',

    //max: this.currentDate,
  };

  omit_number(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_email(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 45 || k == 46 || k == 64 || k == 95 || k == 32);
  }

  omit_text(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  omit_spl(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_all(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 127 && k <= 0));
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
}


////////// backup

